import React from 'react';

import OfficeFilter from 'bundles/apex/filters/office_filter';

import type { Filters } from './types';

type Slice = Pick<Filters, 'officeId'>;
interface Props extends Slice {
  offices: { label: string; value: number; }[];
  onChange: (changes: Slice) => void;
}

export default function TasksIndexFilters({ officeId, offices, onChange }: Props) {

  return (
    <OfficeFilter
      classNamePrefix="search-page-dropdown-filter"
      office={offices.find(office => office.value === officeId) || offices[0]}
      officeOptions={offices}
      onChange={office => onChange({ officeId: office?.value || null })}
    />
  );
}
